export default __webpack_public_path__ + "static/media/logo.d9fb9695.png";